import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'
import { VPRPublicationModel as Model } from './Model'


export const MODULE_NAME = 'vpr-publications'

export const VPR_PUBLICATIONS_PAGES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: VPR_PUBLICATIONS_PAGES_ROUTES.LAYOUT,
  route: { name: VPR_PUBLICATIONS_PAGES_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-book-open-blank-variant',
} as const

export const createUploadFileModal = (
  parent: unknown,
  propsData: Record<string, unknown>,
) => {
  const AsyncComponent = import(
    /* webpackChunkName: "UploadCollectorFileModal" */
    './components/UploadCollectorFileModal.vue'
  )

  const result = createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )

  return result
}
